import { api } from "..";

import { QueryProps } from "@/types/Api";
import { NewUser } from "@/types/ApiResponses/User";

export interface GetSubDealerQueryParams {
  id: number | string;
}

export const getSubDealer = async (
  props: QueryProps<GetSubDealerQueryParams>
): Promise<NewUser> => {
  const res = await api.client.get(`/sub-dealers-new/${props.params.id}`, {
    signal: props.signal,
  });
  return res.data;
};
